import { createContext, useContext } from "react";
import { DriverNamesByIds } from "@/hooks/users/useDriverNamesByIds";

/**
 * The names of the drivers in a grid's rows, looked up once for the whole grid and read by every
 * `DriverCell`. Context rather than a column closure: rebuilding the columns when the names
 * arrive would re-apply the saved grid state.
 */
export const DriverNamesContext = createContext<DriverNamesByIds | undefined>(undefined);

export function useDriverNamesContext(): DriverNamesByIds {
  const lookup = useContext(DriverNamesContext);
  if (!lookup) throw new Error("DriverCell must be rendered inside a DriverNamesContext provider.");
  return lookup;
}
